// Formats a server-provided number as ILS. Display formatting only — no math.
const formatter = new Intl.NumberFormat('he-IL', {
  style: 'currency',
  currency: 'ILS',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatMoney = (value) => formatter.format(Number(value) || 0);

export default function Money({ value, className = '' }) {
  return <span className={`num ${className}`}>{formatMoney(value)}</span>;
}

// What the figure IS, in its colour: a cost red and a profit green on every screen, so
// the two never read alike. Colour only — the value is printed exactly as Money prints it.
export const Cost = ({ value, className = '' }) => <Money value={value} className={`amount-cost ${className}`} />;
// A LOSS IS NOT A PROFIT: below zero it reads in the cost's red, so a figure that lost
// money never looks like one that made it.
export const isLoss = (value) => Number(value) < 0;
export const Profit = ({ value, className = '' }) => (
  <Money value={value} className={`${isLoss(value) ? 'amount-cost' : 'amount-profit'} ${className}`} />
);
